export function cursorPulseAlpha(): number {
  return 0.5
}
